import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getInfo(): AxiosPromise {
  return api.get('v1/ProcessoDiario/ObterProcessoDiario')
}

export function getSupplyMethods(): AxiosPromise {
  return api.get('v1/Fornecedor/Metodos/Pagamentos')
}

export function completeMinimumOrderSupplier(data: any): AxiosPromise {
  return api.put('v1/Fornecedor/Pedidos/Minimo', {
    recomendacaoFornecimentos: data
  })
}

export function getDiscountSupply(data: any): AxiosPromise {
  return api.post('v1/Fornecedor/Descontos', data)
}

export function getSalesChart(
  storeId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Loja/VendasDiarias/Dashboard/${productId}/Produtos/${storeId}/Lojas`
  )
}
export function getStorageChart(
  storeId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Estoque/Movimentos/Dashboard/${productId}/Produtos/${storeId}/Lojas`
  )
}
export function getBuffer(idProduto: number, idLoja: number): AxiosPromise {
  return api.get(`v1/Estoque/Buffers/Loja/${idLoja}/Produto/${idProduto}`)
}

export function getMaintence(_key: string): AxiosPromise {
  return api.get('v1/Infra/Manutencao', {})
}
export function putMaintence(data: {
  Ativo: boolean
  Motivo?: string | null
  Previsao?: string | null
}): AxiosPromise {
  return api.put('v1/Infra/Manutencao', data)
}
export function getConfig(_key: string): AxiosPromise {
  return api.get('v1/Infra/Configuracao?chave=' + _key, {})
}

export function getReportAll(params: string): AxiosPromise {
  return api.get('v1/RelatorioGeral?param=' + params, {})
}
export default {
  getInfo,
  getSalesChart,
  getReportAll,
  getStorageChart,
  getDiscountSupply,
  completeMinimumOrderSupplier,
  getSupplyMethods,
  getBuffer,
  getConfig,
  getMaintence,
  putMaintence
}
